<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "AmountInfo"
}
</script>

<style scoped>

</style>